// This file is kept for backward compatibility
// New card-based configuration is now in src/constants/cards.ts

// Legacy constants - these are now managed per-card in cards.ts
export const WEDDING_DATE = new Date('2025-12-21T11:30:00');
export const VENUE_NAME = "Menara Kembar Bank Rakyat, Dewan Tun Abdul Razak";
export const VENUE_ADDRESS = "No. 33, Jalan Rakyat, Kuala Lumpur Sentral, 50470, Wilayah Persekutuan Kuala Lumpur.";
export const STORAGE_KEY = 'wedding_rsvps';
export const YOUR_GOOGLE_APPS_SCRIPT_URL = "https://script.google.com/macros/s/AKfycbzy_4Mj6M3x5m-ul_VIzd2aFCOsbyGgjxFIdcnA2Jtgh-JIkoeZSueO9XingbV0hanwJw/exec";

// Couple Information
export const BRIDE_NAME = "Zakiah";
export const GROOM_NAME = "Muhammad Azmir";

// Parents Information
export const FATHER_NAME = "Dato' Sri Dr. Mohammed Azman bin Aziz Mohammed";
export const MOTHER_NAME = "⁠Datin Sri Wahinah binti Haroon Rasheed";

// Wedding Details
export const WEDDING_DATE_DISPLAY = "21 Disember 2025";
export const WEDDING_TIME = "11.30 AM";
export const WEDDING_DAY = "Ahad";

export const CONTACTS = [
  { name: "WEDDIE", phone: "+60193000694", role: "Wedding Guest Support" },
];

// Note: These are now card-specific and defined in cards.ts
export const ORGANIZATION_OPTIONS = [
  "Family",
  "Friends",
  "Staff",
];

export const INVITATION_FROM_OPTIONS = [
  "Dato' Sri Dr. Mohammed Azman",
  "⁠Datin Sri Wahinah",
  "Muhammad Azmir & Zakiah"
];
